import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { FiMapPin, FiPhone, FiMail, FiUsers, FiPlusCircle, FiEdit2, FiTrash2, FiChevronRight, FiMonitor } from 'react-icons/fi';
import Navbar from '../components/Navbar';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './AdminHospitalDetails.css';

const hospitalsData = [
  {
    "id": 1,
    "name": "North Hospital Branch",
    "location": "New York",
    "address": "123 Medical Ave, NY 10001",
    "phone": "+1 (555) 123-4567",
    "email": "north@hospital.com",
    "totalDoctors": 42,
    "totalPatients": 560,
    "totalDevices": 120,
    "rating": 4.8
  },
  {
    "id": 2,
    "name": "South Medical Center",
    "location": "Los Angeles",
    "address": "456 Health Blvd, LA 90001",
    "phone": "+1 (555) 987-6543",
    "email": "south@hospital.com",
    "totalDoctors": 38,
    "totalPatients": 490,
    "totalDevices": 95,
    "rating": 4.6
  }
]

function HospitalDetails() {
  const { id } = useParams();
  const hospital = hospitalsData.find(hospital => hospital.id === parseInt(id));

  // Device states - simplified to just display data
  const [hospitalDevices] = useState([
    {
      id: 1,
      name: 'Device Uro',
      status: 'Active',
      imei: '123456789012345'
    }
  ]);

  // Doctor states
  const [hospitalDoctors, setHospitalDoctors] = useState([
    {
      id: 1,
      name: 'Dr. John Smith',
      specialization: 'Cardiology',
      email: 'john.smith@hospital.com',
      phone: '+1 (555) 123-4567',
      availability: 'Mon-Fri, 9AM-5PM'
    }
  ]);
  const [showDoctorForm, setShowDoctorForm] = useState(false);
  const [doctorFormData, setDoctorFormData] = useState({
    name: '',
    specialization: '',
    email: '',
    phone: '',
    availability: ''
  });
  const [editingDoctor, setEditingDoctor] = useState(null);

  // Doctor management functions
  const handleAddDoctor = (e) => {
    e.preventDefault();
    const newDoctor = {
      id: hospitalDoctors.length + 1,
      ...doctorFormData
    };
    setHospitalDoctors([...hospitalDoctors, newDoctor]);
    setDoctorFormData({
      name: '',
      specialization: '',
      email: '',
      phone: '',
      availability: ''
    });
    setShowDoctorForm(false);
  };

  const handleEditDoctor = (doctor) => {
    setEditingDoctor(doctor.id);
    setDoctorFormData(doctor);
    setShowDoctorForm(true);
  };

  const handleUpdateDoctor = (e) => {
    e.preventDefault();
    setHospitalDoctors(hospitalDoctors.map(doctor => 
      doctor.id === editingDoctor ? { ...doctor, ...doctorFormData } : doctor
    ));
    setEditingDoctor(null);
    setDoctorFormData({
      name: '',
      specialization: '',
      email: '',
      phone: '',
      availability: ''
    });
    setShowDoctorForm(false);
  };

  const handleDeleteDoctor = (doctorId) => {
    if (window.confirm('Are you sure you want to delete this doctor?')) {
      setHospitalDoctors(hospitalDoctors.filter(doctor => doctor.id !== doctorId));
    }
  };

  const handleDoctorFormChange = (e) => {
    const { name, value } = e.target;
    setDoctorFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <div className="hospital-page">
      <Navbar />
      <div className="hospital-container">
        <div className="hospital-header">
          <div className="header-content">
            <div className="breadcrumb">
              <Link to="/dashboard">Dashboard</Link>
              <FiChevronRight className="separator" />
              <Link to="/dashboard/hospital">Hospitals</Link>
              <FiChevronRight className="separator" />
              <span>{hospital.name}</span>
            </div>
            <h1>{hospital.name}</h1>
          </div>
        </div>

        <div className="hospital-content">
          <div className="hospital-info">
            <div className="info-grid">
              <div className="info-item">
                <FiMapPin />
                <div>
                  <label>Location</label>
                  <p>{hospital.location}</p>
                  <p>{hospital.address}</p>
                </div>
              </div>
              <div className="info-item">
                <FiPhone />
                <div>
                  <label>Contact</label>
                  <p>{hospital.phone}</p>
                </div>
              </div>
              <div className="info-item">
                <FiMail />
                <div>
                  <label>Email</label>
                  <p>{hospital.email}</p>
                </div>
              </div>
            </div>
          </div>

          <div className="stats-section">
            <div className="stat-card">
              <FiUsers />
              <div>
                <h3>{hospital.totalDoctors}</h3>
                <p>Total Doctors</p>
              </div>
            </div>
            <div className="stat-card">
              <FiUsers />
              <div>
                <h3>{hospital.totalPatients}</h3>
                <p>Total Patients</p>
              </div>
            </div>
            <div className="stat-card">
              <FiMonitor />
              <div>
                <h3>{hospital.totalDevices}</h3>
                <p>Total Devices</p>
              </div>
            </div>
          </div>

          <div className="content-row">
            <div className="doctors-section">
              <div className="section-header">
                <h3>Doctors</h3>
                <button 
                  className="add-doctor-btn"
                  onClick={() => {
                    setEditingDoctor(null);
                    setDoctorFormData({
                      name: '',
                      specialization: '',
                      email: '',
                      phone: '',
                      availability: ''
                    });
                    setShowDoctorForm(true);
                  }}
                >
                  <FiPlusCircle /> Add Doctor
                </button>
              </div>

              {showDoctorForm && (
                <form className="doctor-form" onSubmit={editingDoctor ? handleUpdateDoctor : handleAddDoctor}>
                  <div className="form-row">
                    <div className="form-group">
                      <label>Doctor Name</label>
                      <input
                        type="text"
                        name="name"
                        value={doctorFormData.name}
                        onChange={handleDoctorFormChange}
                        placeholder="Enter doctor's full name"
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label>Specialization</label>
                      <input
                        type="text"
                        name="specialization"
                        value={doctorFormData.specialization}
                        onChange={handleDoctorFormChange}
                        placeholder="Enter specialization"
                        required
                      />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      <label>Email</label>
                      <input
                        type="email"
                        name="email"
                        value={doctorFormData.email}
                        onChange={handleDoctorFormChange}
                        placeholder="Enter email address"
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label>Phone</label>
                      <input
                        type="tel"
                        name="phone"
                        value={doctorFormData.phone}
                        onChange={handleDoctorFormChange}
                        placeholder="Enter phone number"
                        required
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <label>Availability</label>
                    <input
                      type="text"
                      name="availability"
                      value={doctorFormData.availability}
                      onChange={handleDoctorFormChange}
                      placeholder="Enter availability (e.g., Mon-Fri, 9AM-5PM)"
                      required
                    />
                  </div>
                  <div className="form-actions">
                    <button type="submit" className="submit-btn">
                      {editingDoctor ? 'Update Doctor' : 'Add Doctor'}
                    </button>
                    <button 
                      type="button" 
                      className="cancel-btn"
                      onClick={() => setShowDoctorForm(false)}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              )}

              <div className="doctors-grid">
                {hospitalDoctors.map(doctor => (
                  <div key={doctor.id} className="doctor-card">
                    <div className="doctor-card-header">
                      <h4>{doctor.name}</h4>
                      <div className="doctor-actions">
                        <button
                          className="action-btn edit"
                          onClick={() => handleEditDoctor(doctor)}
                        >
                          <FiEdit2 />
                        </button>
                        <button
                          className="action-btn delete"
                          onClick={() => handleDeleteDoctor(doctor.id)}
                        >
                          <FiTrash2 />
                        </button>
                      </div>
                    </div>
                    <div className="doctor-info">
                      <p><strong>Specialization:</strong> {doctor.specialization}</p>
                      <p><strong>Email:</strong> {doctor.email}</p>
                      <p><strong>Phone:</strong> {doctor.phone}</p>
                      <p><strong>Availability:</strong> {doctor.availability}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="devices-section">
              <div className="section-header">
                <h3>Devices</h3>
              </div>

              <div className="devices-grid">
                {hospitalDevices.map(device => (
                  <div key={device.id} className="device-card">
                    <div className="device-card-header">
                      <h4>{device.name}</h4>
                    </div>
                    <div className="device-info">
                      <p><strong>Status:</strong> {device.status}</p>
                      <p><strong>IMEI:</strong> {device.imei}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        limit={3}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
    </div>
  );
}

export default HospitalDetails;
